import React, { useEffect } from "react"
import styles from "./index.module.scss"
import { EditIcon } from "../../../assets/icons/Edit"
import { Order } from "../OrderTable"
import { Copy } from "../../../assets/icons/Copy"
import RcmpLoading from "../../atoms/Loading"
import intl from "react-intl-universal"
import { Tooltip } from "../Tooltip"
import { fnisOnlyPermition } from "../../../utils/verifyPermitions"

function TableComponent({
  load,
  thead,
  tbodyArray,
  handleClickSettings,
  handleClickCopy,
  cursorNormal = false,
  cTextNoData = intl.get("no_data"),
  bNotShowIfEmpty = false,
  fnOrder,
  loadingInnerTable,
  cActiveArrowOrder,
  bCopy = false,
  bEdit = true,
  isPermition = false
}) {
  const [activeColumnIndex, setActiveColumnIndex] = React.useState(null)

  const isOnlyAccessModuleCiq = fnisOnlyPermition("access-ciq") || isPermition

  const fnLasPosition = (idx, th, conditionOne, conditionTwo) => {
    return idx === th.length - 1 && idx === 5 ? conditionOne : conditionTwo
  }

  useEffect(() => {
    if (cActiveArrowOrder === "control_vstatus") {
      const columStatus = document.getElementById("Status")
      if (columStatus) {
        columStatus.click()
      }
    }
  }, [tbodyArray?.length > 0])

  if (!tbodyArray || tbodyArray.length === 0) {
    if (load) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
            width: "100%",
          }}
        >
          <RcmpLoading bShow={true} size={50} />
        </div>
      )
    }
    if (bNotShowIfEmpty) {
      return <></>
    }
    return (
      <>
        <table className={styles.table}>
          <thead className={styles.head}>
            <tr>
              {thead.map((item, index, array) => (
                <th
                  className="th"
                  key={index}
                  style={{
                    textAlign: item === "Ações" ? "center" : "left",
                  }}
                >
                  <span className={styles.noText}>{item}</span>
                </th>
              ))}
            </tr>
          </thead>
        </table>
        <p className={styles.textNoData}>{cTextNoData}</p>
      </>
    )
  }

  const columns = Object.keys(tbodyArray[0])

  const fnOrderColumnBy = (ev, index, columns) => {
    if (index === thead.length - 1) return

    document.querySelectorAll(".th").forEach((item) => {
      item.classList.remove(styles.opacity)
    })

    ev.currentTarget?.classList.add(styles.opacity)

    const isActive = index === activeColumnIndex

    setActiveColumnIndex(isActive ? null : index)

    if (columns[index].includes("nid")) {
      return
    }
    if (fnOrder) {
      fnOrder(columns[index], !isActive ? "asc" : "desc")
    }
  }

  return (
    <div className={styles.containerTable}>
      <table className={styles.table}>
        <thead className={styles.head}>
          <tr>
            {thead.map((item, index) => (
              <th
                key={index}
                style={{
                  textAlign: bCopy
                    ? "center"
                    : fnLasPosition(index, thead, "center", "left"),
                  cursor: fnLasPosition(index, thead, "default", "pointer"),
                }}
                id={item}
                className={`${
                  item.toLowerCase().includes("name") || item.includes("observation")
                    ? styles.widthLarge
                    : styles.widthNormal
                } th`}
                onClick={(ev) => {
                  fnOrderColumnBy(ev, index, columns)
                }}
              >
                {!columns[index].includes("nid") ? (
                  <span>
                    {item}
                    {typeof fnOrder === "function" && (
                      <Order
                        columnIndex={index}
                        activeColumnIndex={activeColumnIndex}
                        setActiveColumnIndex={setActiveColumnIndex}
                      />
                    )}
                  </span>
                ) : (
                  item
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={styles.tableBody}>
          {loadingInnerTable ? (
            <></>
          ) : (
            tbodyArray?.map((item, rowIndex) => (
              <tr
                key={rowIndex}
                style={{
                  cursor: cursorNormal ? "default" : "pointer",
                }}
              >
                {columns
                  .filter((item) => !item.includes("id"))
                  .map((column, columnIndex) => (
                    <td
                      key={columnIndex}
                      className={`${styles.td} ${
                        column.includes("name") || column.includes("observation")
                          ? styles.widthLarge
                          : styles.widthNormal
                      }`}
                    >
                      {column.includes("bstatus") ? (
                        <span
                          className={`${
                            item[column] === "Ativo" || item[column] === "Active"
                              ? styles.ativo
                              : styles.inativo
                          }`}
                          style={{ textTransform: "capitalize !important" }}
                        >
                          {item[column]}
                        </span>
                      ) : item[column]?.length === 0 || item[column] === null ? (
                        " - "
                      ) : column.includes("observation") ? (
                        item[column]?.length > 20 ? (
                          item[column].slice(0, 20) + "..."
                        ) : (
                          item[column]
                        )
                      ) : column.includes("vstatus") ? (
                        <span
                          className={`${
                            item[column] === 1
                              ? styles.overdue
                              : item[column] === 2
                              ? styles.dueSoon
                              : item[column] === 3
                              ? styles.ativo
                              : styles.inativo
                          }`}
                        >
                          {item[column] === 1
                            ? intl.get("ciq.overdue")
                            : item[column] === 2
                            ? intl.get("ciq.due_soon")
                            : item[column] === 3
                            ? intl.get("ciq.list_analytes.active")
                            : intl.get("ciq.list_analytes.inactive")}
                        </span>
                      ) : (
                        item[column]
                      )}
                    </td>
                  ))}

                {bEdit && (
                  <td
                    style={{
                      display: bCopy ? "flex" : "table-cell",
                      textAlign: "center",
                      width: bCopy ? "auto" : "7rem",
                      justifyContent: bCopy ? "center" : "flex-start",
                      cursor: isOnlyAccessModuleCiq ? "not-allowed" : "pointer",
                    }}
                  >
                    <div
                      className={styles.containerAction}
                      onClick={() => {
                        if (isOnlyAccessModuleCiq) return
                        handleClickSettings(item)
                      }}
                    >
                      <Tooltip
                        icon={<EditIcon />}
                        name={intl.get("edit_cap")}
                        isOnlyAccessModuleCiq={isOnlyAccessModuleCiq}
                      />
                    </div>
                    {bCopy && (
                      <div
                        className={styles.containerAction}
                        onClick={() => {
                          if (isOnlyAccessModuleCiq) return

                          handleClickCopy(item)
                        }}
                      >
                        <Tooltip
                          icon={<Copy />}
                          name={intl.get("duplicate")}
                          isOnlyAccessModuleCiq={isOnlyAccessModuleCiq}
                        />
                      </div>
                    )}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>

      {loadingInnerTable && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1rem",
              borderRadius: "4px",
              width: "100%",
            }}
          >
            <RcmpLoading bShow={true} size={50} />
          </div>
        </>
      )}
    </div>
  )
}

export const Table = React.memo(TableComponent)
